/**
 * The main api service
 */
import http from '@util/http';
import {incubator} from '@api/req';

export async function queryIncuBaseList(params) {
  return http.get(incubator.INCUBATOR_BASE_LIST, params);
}

export async function queryIncuBaseInfo(params) {
  return http.get(incubator.INCUBATOR_BASE_INFO, params);
}

export async function querySaveIncubator(params) {
  return http.post(incubator.INCUBATOR_BASE_SAVE, params);
}

export async function queryIncubatorIncome(params) {
  return http.get(incubator.INCUBATOR_BASE_INCOME, params);
}

export async function queryIncubatorRefundTodo(params) {
  return http.get(incubator.INCUBATOR_BASE_REFUND_TODO, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/base.js